import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/RecurringRevenueSagas";
const CompareType = () => {
  const dispatch = useDispatch();
  const {
    compareTypes,
    selectedFilters: { compare_type }
  } = useSelector((state) => state.recurringRevenue);
  return (
    <MultiSelectDropdown
      filterType="Custom Range"
      options={compareTypes}
      selectedFilters={compare_type}
      numberDisplayed={0}
      maxSelect={1}
      enableMax
      enableDefaultSelected
      haveOnSelectChange={false}
      includeFilter={false}
      updateLocations={(data) => dispatch(actionCreators.updateCompareType(data))}
    />
  );
};

export default CompareType;
